module.exports = __webpack_public_path__ + "img/VP-Classic_Overview-Front_2.a665a0a8.jpg";